import { render, staticRenderFns } from "./allCategories.vue?vue&type=template&id=8aabd8c6&scoped=true"
import script from "./allCategories.vue?vue&type=script&lang=js"
export * from "./allCategories.vue?vue&type=script&lang=js"
import style0 from "./allCategories.vue?vue&type=style&index=0&id=8aabd8c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aabd8c6",
  null
  
)

export default component.exports